import { render, staticRenderFns } from "./infoLayout.vue?vue&type=template&id=83c0f1e0&scoped=true"
import script from "./infoLayout.vue?vue&type=script&lang=js"
export * from "./infoLayout.vue?vue&type=script&lang=js"
import style0 from "./infoLayout.vue?vue&type=style&index=0&id=83c0f1e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c0f1e0",
  null
  
)

export default component.exports